export interface SOLRConfig {
	consultant: string;
}
/**
 * Loads the solr consultant variable from environment variables.
 *
 * @return the loaded SOLRConfig object.
 * @throws IllegalStateException if the solr config is not set.
 */
export function loadSolrConfig(): SOLRConfig {
	const { SOLR_SERVER_CON_WISH_SHOW_ENDPOINT } = process.env;

	if (!SOLR_SERVER_CON_WISH_SHOW_ENDPOINT) {
		throw new Error(
			"SOLR_SERVER_CON_WISH_SHOW_ENDPOINT config is not set."
		);
	}

	return {
		consultant: SOLR_SERVER_CON_WISH_SHOW_ENDPOINT
	};
}
